import React from 'react';

const Container = ({
  children,
  className = '',
  hasPadding = true,
  singleColumn,
}) => (
  <section
    className={` max-w-3xl ${
      hasPadding && 'px-4'
    } lg:mx-auto grid grid-cols-1 ${
      singleColumn ? 'lg:grid-cols-1' : 'lg:grid-cols-2'
    }  ${className || ''}`}
  >
    {children}
  </section>
);

export default Container;
